<template>
  <v-container
    style="padding: 0; margin: 0;"
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      v-if="empUser === null"
      justify-center
      wrap
    >
      <h2>{{ strings[idioma].vincular }} {{ user.NOME }} ({{ user.id }})</h2>
      <v-flex
        xs12
        md12
      >
        <material-card
          v-if="empresas && empresa === null"
          color="secundary"
          text=""
          xs12
        >
          <v-sheet class="pa-3 black">
            <v-layout
              row
              wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="searchEmpresas"
                  :label="strings[idioma].empresas"
                  dark
                  flat
                  solo-inverted
                  hide-details
                  clearable
                  append-icon="mdi-magnify"
                  clear-icon="mdi-close"
                />
              </v-flex>
            </v-layout>
          </v-sheet>
          <div style="max-height: 300px; width: 100%; overflow:auto;">
            <v-list
              dense
              flat
              rounded>
              <v-list-tile
                v-for="us in empresasFilter"
                :key="us.id"
                :style="us.EXCLUIDO === 1 ? 'opacity: 0.6;': null"
                flat
                @click="vincular(us)">

                <v-list-tile-avatar>
                  <v-icon
                    v-if="us.EXCLUIDO !== 1"
                    :color="(us.permissao === 0) ? 'red': ''"
                    v-text="'mdi-domain'"
                  />
                  <v-icon
                    v-else
                    :color="(us.permissao === 0) ? 'red': ''"
                    v-text="'mdi-domain-off'"
                  />
                </v-list-tile-avatar>
                <v-list-tile-action>
                  <span>{{ us.id }}</span>
                </v-list-tile-action>
                <v-list-tile-content style="min-width: 70%">
                  <v-list-tile-title

                    class = "text-uppercase"
                  > {{ us.nome_fantasia }}({{ us.nome }}) </v-list-tile-title>
                  <v-list-tile-sub-title>{{ $formatCnpjCpf(String(us.cnpj)) }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </div>
        </material-card>
        <h2 v-else>- {{ empresa.nome }}</h2>
      </v-flex>
      <v-flex
        v-if="empresa !== null"
        xs12
        md12
      >
        <material-card>
          <v-flex md12>
            <v-autocomplete
              v-model="cargo"
              :label="strings[idioma].cargo"
              :items="Cargos"
              :item-text="'nome'"
              :browser-autocomplete="rand()"
              no-data-text=""
              class="purple-input"
            />
          </v-flex>
          <v-flex md12>
            <v-checkbox
              v-model="vinculadoATodos"

              :label="strings[idioma].vincular_a_todos"
              :browser-autocomplete="rand()"
              no-data-text=""
              class="purple-input"
            />
          </v-flex>
          <v-flex md12>
            <v-autocomplete
              v-model="gestorResponsavel"
              :label="strings[idioma].gestor_responsavel"
              :items="Gestores"
              :item-text="'NOME'"
              :item-value="'id'"
              :browser-autocomplete="rand()"
              no-data-text=""
              class="purple-input"
              @change="vinculadoATodos = false"
            />
          </v-flex>
          <v-flex md12>
            <v-btn @click="cadastra">{{ strings[idioma].vincular }}</v-btn>
          </v-flex>
        </material-card>
      </v-flex>

    </v-layout>
    <v-layout
      v-else
      justify-center
      wrap
    >
      <h2>{{ strings[idioma].vincular }} {{ user.NOME }} ({{ user.id }})</h2>

      <v-flex
        xs12
        md12
      >
        <v-flex md12>
          <v-btn @click="desvincula">{{ strings[idioma].desvincular }}</v-btn>
        </v-flex>
        <material-card
          color="secundary"
          text=""
          xs12
        >
          <v-sheet class="pa-3 black">
            <v-layout
              row
              wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="searchEmpresas"
                  :label="strings[idioma].empresas"
                  dark
                  flat
                  solo-inverted
                  hide-details
                  clearable
                  append-icon="mdi-magnify"
                  clear-icon="mdi-close"
                />
              </v-flex>
            </v-layout>
          </v-sheet>
          <div style="max-height: 300px; width: 100%; overflow:auto;">
            <v-list
              dense
              flat
              rounded>
              <v-list-tile
                v-for="us in empresasFilter"
                :key="us.id"
                :style="us.EXCLUIDO === 1 ? 'opacity: 0.6;': us.id === empUser.id_empresa ? 'background: #e1e1e1' : null"
                flat
                @click="vincular(us)">

                <v-list-tile-avatar>
                  <v-icon
                    v-if="us.EXCLUIDO !== 1"
                    :color="(us.permissao === 0) ? 'red': ''"
                    v-text="'mdi-domain'"
                  />
                  <v-icon
                    v-else
                    :color="(us.permissao === 0) ? 'red': ''"
                    v-text="'mdi-domain-off'"
                  />
                </v-list-tile-avatar>
                <v-list-tile-action>
                  <span>{{ us.id }}</span>
                </v-list-tile-action>
                <v-list-tile-content style="min-width: 70%">
                  <v-list-tile-title

                    class = "text-uppercase"
                  > {{ us.nome_fantasia }}({{ us.nome }}) </v-list-tile-title>
                  <v-list-tile-sub-title>{{ $formatCnpjCpf(String(us.cnpj)) }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </div>
        </material-card>
      </v-flex>
      <v-flex
        xs12
        md12
      >
        <material-card>
          <v-flex md12>
            <v-autocomplete
              v-model="cargo"
              :label="strings[idioma].cargo"
              :items="Cargos"
              :item-text="'nome'"
              :browser-autocomplete="rand()"
              no-data-text=""
              class="purple-input"
            />
          </v-flex>
          <v-flex md12>
            <v-checkbox
              v-model="vinculadoATodos"
              :label="strings[idioma].vincular_a_todos"
              :browser-autocomplete="rand()"
              disabled
              no-data-text=""
              class="purple-input"
            />
          </v-flex>
          <v-flex md12>
            <v-autocomplete
              v-model="gestorResponsavel"
              :label="strings[idioma].gestor_responsavel"
              :items="Gestores"
              :item-text="'NOME'"
              :item-value="'id'"
              :browser-autocomplete="rand()"
              disabled
              no-data-text=""
              class="purple-input"
              @change="vinculadoATodos = false"
            />
          </v-flex>
          <v-flex md12>
            <v-btn @click="cadastra">{{ strings[idioma].vincular }}</v-btn>
          </v-flex>
        </material-card>
      </v-flex>

    </v-layout>

  </v-container>
</template>

<script>
import { estados, paises } from '../../lang/Strings'
import { mapState } from 'vuex'
import {
  replaceSpecialChars
} from '@/utils/vuex'
import { EMPRESA_GESTOR, EMPRESA_GERENTE_REGIONAL, EMPRESA_TECNICO_VENDA, EMPRESA_PRODUTOR_VINCULADO, EMPRESA_TIPOS } from '../../utils/types'
export default {
  data: () => ({
    empUser: null,
    user: null,
    users: [],
    empresas: [],
    cargo: null,
    searchEmpresas: null,
    empresa: null,
    empresa_: null,
    loading: false,
    cnpjRules: null,
    EMPRESA_GESTOR: EMPRESA_GESTOR,
    EMPRESA_GERENTE_REGIONAL: EMPRESA_GERENTE_REGIONAL,
    EMPRESA_TECNICO_VENDA: EMPRESA_TECNICO_VENDA,
    EMPRESA_PRODUTOR_VINCULADO: EMPRESA_PRODUTOR_VINCULADO,
    EMPRESA_TIPOS: EMPRESA_TIPOS,
    gestorResponsavel: null,
    vinculadoATodos: true,
    gestores: []
  }),
  computed: {
    ...mapState('app', ['idioma', 'strings', 'empresa', 'acesso']),
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 289) + 'px'
    },
    heightDialog () {
      return this.$vuetify.breakpoint.xs ? String(this.$vuetify.breakpoint.height - 150) + 'px' : String(this.$vuetify.breakpoint.height - 240) + 'px'
    },
    heightempresaOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 20) + 'px; overflow: auto;'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 50) + 'px; overflow: auto;'
    },
    heightTree () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 330) + 'px; overflow: auto; min-height: 200px;'
    },
    Gestores () {
      return this.gestores
    },
    Usuarios () {
      return this.users
    },
    Cargos () {
      return [
        { 'nome': this.strings[this.idioma]['empresa_gestor'], 'nivel': 0, 'id': 'empresa_gestor' },
        { 'nome': this.strings[this.idioma]['empresa_gerente_regional'], 'nivel': 1, 'id': 'empresa_gerente_regional' },
        { 'nome': this.strings[this.idioma]['empresa_tecnico_venda'], 'nivel': 2, 'id': 'empresa_tecnico_venda' },
        { 'nome': this.strings[this.idioma]['empresa_produtor_vinculado'], 'nivel': 3, 'id': 'empresa_produtor_vinculado' }

      ]
    },
    UnidadesFederativas () {
      return estados
    },
    Cidades () {
      let cidades = estados.filter(e => e.sigla === this.empresa_.endereco.estado)
      return cidades.length > 0 ? cidades[0].cidades : []
    },
    Paises () {
      return paises
    },
    Proprietario () {
      let prop = this.users.filter(u => u.id === this.empresa_.id_proprietario)
      return prop.length > 0 ? prop[0] : []
    },
    Empresas () {
      return this.empresas
    },
    empresasFilter () {
      if (this.searchEmpresas === null || this.searchEmpresas.trim() === '') return this.empresas
      return this.empresas.filter(u => new RegExp(replaceSpecialChars(this.searchEmpresas.toLowerCase()), 'i').test(u.nome))
    }
  },
  watch: {
    'vinculadoATodos' (val) {
      if (val) this.gestorResponsavel = null
    }
  },
  created () {
    this.axios.post('users/get', {}).then(r => { this.users = r.data.data.users }).catch(() => this.$router.push('/'))
    this.user = JSON.parse(sessionStorage.getItem('userLoad'))
    this.empUser = (sessionStorage.getItem('empUser')) ? JSON.parse(sessionStorage.getItem('empUser')) : null
    this.axios.post('empresa/getEmpresas', {}).then(r => {
      this.empresas = r.data.data.empresas
      if (this.empUser !== null) {
        this.empUser.user = this.users.filter(us => this.empUser.id_user === us.id)[0]
        this.empresa = this.empUser.empresa = this.empresas.filter(us => this.empUser.id_empresa === us.id)[0]
        this.cargo = this.Cargos.filter(c => c.nivel === this.empUser.acesso)[0].nome
        if (!this.empUser.supervisor) this.vinculadoATodos = true
        else {
          this.gestorResponsavel = this.empUser.supervisor.id_pessoa
          this.vinculadoATodos = false
        }
        this.axios.post('empresa/getGestores', { id_empresa: this.empresa.id }).then(r => {
          this.gestores = r.data.data
          
        })
      }
    }).catch(() => this.$router.push('/'))
    // localStorage.removeItem('empresaLoad')
    this.reset()
  },
  methods: {
    vincular (emp) {
      this.empresa = emp
      this.axios.post('empresa/getGestores', { id_empresa: this.empresa.id }).then(r => {
        this.gestores = r.data.data
        
      })
      if (this.empUser !== null) {
        this.empUser.id_empresa = emp.id
        this.empUser.empresa = emp
      }
    },
    desvincula () {
      let empresa = this.empresa
      let usuario = this.user
      let cargo = this.cargo
      console.log(this.Cargos.filter(c => cargo === c.nome)[0], cargo)
      let acesso = this.Cargos.filter(c => cargo === c.nome)[0].nivel
      this.axios.post('empresa/desvincula', { id_empresa: empresa.id, id_pessoa: usuario.id, acesso: acesso, autorizado: 0, vinculado_a_todos: this.vinculadoATodos, gestor_responsavel: this.gestorResponsavel }).then(response => {
        let msg = 'Desvinculado!!!'
        let title = ''
        this.$store.commit('openOKModal', { title, msg })
        this.voltar()
      })
    },
    cadastra () {
      let empresa = this.empresa
      console.log(this.empresa)
      let usuario = this.user
      let cargo = this.cargo
      let acesso = this.Cargos.filter(c => cargo === c.nome)[0].nivel
      this.axios.post('empresa/vincula', { id_empresa: empresa.id, id_pessoa: usuario.id, acesso: acesso, autorizado: 1, lido: 0, vinculado_a_todos: this.vinculadoATodos, gestor_responsavel: this.gestorResponsavel }).then(response => {
        let msg = 'Vinculado!!!'
        let title = ''
        this.$store.commit('openOKModal', { title, msg })
        this.voltar()
      })
    },
    changeProprietario () {
      let prop = this.users.filter(u => u.email === this.empresa_.email_proprietario)[0]
      this.empresa_.id_proprietario = prop.id
    },
    voltar () {
      window.history.back()
    },
    parseString (valor, idioma) {
      if ((idioma === 0 || idioma === 2) && valor && valor !== '-') {
        if (valor[valor.length - 3] === '.') return parseFloat(valor)
        return parseFloat(valor.replace(/[.]/g, '').replace(/[,]/g, '.'))
      } else if (valor && valor !== '-') {
        return parseFloat(valor.replace(/[,]/g, ''))
      }
      return 0
    },
    cnpjValidator (val, input, tipo) {
      return this.$testaCNPJ(String(input[tipo]))
    },
    reset () {
      this.empresa_ = Object.assign({}, this.empresa)
    },
    update () {
      this.axios.post('empresa/create', { id: this.empresa.id, id_proprietario: this.Proprietario.id, email: this.empresa_.email, email_financeiro: this.empresa_.email_financeiro, nome: this.empresa_.nome, nome_fantasia: this.empresa_.nome_fantasia, razao_social: this.empresa_.razao_social, inscricao_estadual: this.empresa_.inscricao_estadual, telefone: this.empresa_.telefone, telefoneFinanceiro: this.empresa_.telefoneFinanceiro, endereco: this.empresa_.endereco, enderecoFinanceiro: this.empresa_.enderecoFinanceiro, cnpj: this.empresa_.cnpj, EXCLUIDO: this.empresa_.EXCLUIDO, permissao: this.empresa_.permissao }).then(response => {
        this.empresa.nome = this.empresa_.nome
        this.empresa.email = this.empresa_.email
        this.empresa.email_financeiro = this.empresa_.email_financeiro
        this.empresa.id_proprietario = this.empresa_.id_proprietario
        this.empresa.razao_social = this.empresa_.razao_social
        this.empresa.nome_fantasia = this.empresa_.nome_fantasia
        this.empresa.endereco = this.empresa_.endereco
        this.empresa.telefone = this.empresa_.telefone

        this.empresa.enderecoFinanceiro = this.empresa_.enderecoFinanceiro
        this.empresa.telefoneFinanceiro = this.empresa_.telefoneFinanceiro
        this.empresa.cnpj = this.empresa_.cnpj
        this.empresa.EXCLUIDO = this.empresa_.EXCLUIDO
        this.empresa.permissao = this.empresa.permissao
        let msg = this.strings[this.idioma].cadastrado
        let title = this.strings[this.idioma].editar_perfil
        this.$store.commit('openOKModal', { title, msg })
        this.voltar()
      })
    },
    mudarSenha () {
      this.loading = true
      this.axios.post('/auth/esqueciSenha', { email: this.empresa.email }).then(response => {
        this.loading = false
        let msg = this.strings[this.idioma].enviado
        let title = this.strings[this.idioma].mudanca_senha
        this.$store.commit('openOKModal', { title, msg })
      }).catch(reason => {
        this.loading = false
        let msg = this.strings[this.idioma].usuario_nao_encontrado
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
      })
    },
    verificaEmail (fn = null, fncatch = null) {
      if (this.empresa_.email.trim() === this.empresa.email.trim()) {
        fncatch(this.empresa.email)
        return
      }
      this.axios.post('/auth/verificaEmail', { email: this.empresa_.email }).then(() => {
        this.empresa_.email = this.empresa.email
        let msg = 'E-Mail já existente!!!'
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
        if (fn !== null) {
          fn(this.empresa_.email)
        }
      }).catch(() => {
        if (fncatch !== null) {
          fncatch(this.empresa_.email)
        }
      })
    },
    rand () {
      return Math.random()
    }
  }
}
</script>
